import { resolveHTTP } from '@/services/api'

const Api = resolveHTTP('/bl/process-items')

Api.storeByFileRoute = () => {
  return Api.apiURl + Api.relativeUrl + '/store-by-file'
}

export default Api



// WEBPACK FOOTER //
// ./src/services/api/bl-processitems.js